import { grey } from './colors'

export const borders = {
  thin: '1px solid',
  medium: '2px solid',
  large: '4px solid',
  base: `1px solid ${grey['50']}`
}
